export default __webpack_public_path__ + "static/media/youtubered.19452550.svg";